// extracted by mini-css-extract-plugin
export default {"wrap":"AssetCard_wrap__GZ3uW","name":"AssetCard_name__41UaX","meta":"AssetCard_meta__O4J3d","metaItem":"AssetCard_metaItem__YBCL5"};